import { Card, Col, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { DismissibleAlert } from '@components/Tickets/Alerts';
import { OpenTicketsTable } from '@components/Tickets/TicketsTable';
import { HTTP_503_SERVICE_UNAVAILABLE } from '@config/const';
import { Page500 } from '@containers/ErrorPages';
import { ticketApi } from '@reducers/tickets/tickets';

export const OpenTickets = () => {
  const location = useLocation();
  const { data, isLoading, isError, error } = ticketApi.useGetOpenQuery();
  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    if (error.status === HTTP_503_SERVICE_UNAVAILABLE) {
      return (
        <Page500 title="Service unavailable" getMessage={() => error.data} />
      );
    }
    return <Page500 />;
  }
  const { created, data: message } = location?.state ? location.state : {};
  return (
    <>
      {created ? <DismissibleAlert message={message} /> : null}
      <Row>
        <Col md={12}>
          <Card>
            <Card.Header className="bg-didxl text-white">
              Open Tickets
            </Card.Header>
            <Card.Body>
              {isError ? (
                <span className="textRed">{error.data}</span>
              ) : (
                <OpenTicketsTable data={data} />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};
